import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const { exchangeGoogle } = useAuth();
  const navigate = useNavigate();
  const processed = React.useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/login"); return; }
    (async () => {
      try {
        await exchangeGoogle(decodeURIComponent(match[1]));
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard");
      } catch {
        navigate("/login");
      }
    })();
  }, [exchangeGoogle, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-6 bg-slate-50">
      <Logo size="lg" />
      <div className="flex items-center gap-2 text-slate-500"><Loader2 className="animate-spin" size={18} /> Signing you in…</div>
    </div>
  );
}
